import { qs } from "@fluorescent/dom";

import ProductItem from "@/lib/product-item";
import getMediaQuery from "@/lib/media-queries";
import atBreakpointChange from "@/lib/at-breakpoint-change";
import Carousel from "@/lib/carousel";

const selectors = {
  featuredProducts: "[data-featured-products]",
  leftSideMobileFeaturedProducts:
    ".left-side-blocks.for-mobile [data-featured-products]",
};

const featuredProducts = node => {
  // Left column blocks are rendered twice to keep correct
  // ordering with right column blocks on mobile. Here we
  // target the mobile left version if it exists as it requires
  // the potential mobile swiper only.
  const featuredProducts =
    qs(selectors.leftSideMobileFeaturedProducts, node) ||
    qs(selectors.featuredProducts, node);

  if (!featuredProducts) return;

  const enableMobileSwiper =
    featuredProducts.dataset.enableMobileSwiper === "true";
  const productItem = ProductItem(featuredProducts);
  let mobileSwiper;

  if (enableMobileSwiper) {
    if (window.matchMedia(getMediaQuery("below-720")).matches) {
      _initMobileSwiper();
    }

    atBreakpointChange(720, () => {
      if (window.matchMedia(getMediaQuery("below-720")).matches) {
        _initMobileSwiper();
      } else {
        mobileSwiper?.destroy();
      }
    });
  }

  function _initMobileSwiper() {
    mobileSwiper = Carousel(featuredProducts, {
      slidesPerView: 2.1,
      spaceBetween: 12,
    });
  }

  function unload() {
    productItem.unload();
    mobileSwiper?.destroy();
  }

  return { unload };
};

export default featuredProducts;
